import type { ParseKeys } from "i18next";

import type { IInfiniteDropdownType } from "@/api/infiniteDropdowns";
import type { IIconName } from "@/components/icons";

export const fastInfiniteVariant: Record<
  IInfiniteDropdownType,
  { title: ParseKeys<"form">; iconName: IIconName }
> = {
  hf: {
    title: "hf",
    iconName: "Hospital",
  },
  doctor: {
    title: "doctor",
    iconName: "UserRounded",
  },
  patient: {
    title: "patientName",
    iconName: "UserRounded",
  },
  staff: {
    title: "staff",
    iconName: "UserRounded",
  },
  assignableDoctorsToStaff: {
    title: "doctor",
    iconName: "UserRounded",
  },
  assignableDoctorsToMsp: {
    title: "doctor",
    iconName: "UserRounded",
  },
  patterns: {
    title: "pattern_name",
    iconName: "MedalRibbonStar",
  },
  suggestedPatterns: {
    title: "suggested_templates",
    iconName: "MedalRibbonStar",
  },
  terminologies: {
    title: "disease_name",
    iconName: "MedalRibbonStar",
  },
  visitHistories: {
    title: "visitHistories",
    iconName: "Calendar",
  },
  diseases: {
    title: "disease_name",
    iconName: "MedalRibbonStar",
  },
  mspName: {
    title: "mspName",
    iconName: "Hospital",
  },
};
